export * from './prices';
export * from './conversions';
export * from './variables';
export * from './notifications';

export const getUrlSearch = () => window.location.search.slice(1);

export const scrollToTop = () =>
	window.scrollTo({ top: 0, behavior: 'smooth' });

export const cacheProps = {
	fetchOnMount: true,
	refetchOnWindowFocus: true,
	refetchOnReconnect: true
};
